<div class="wrapper">
  <div class="table-container">
    <div class="d-flex filters">
      <div class="form-group">
        <label for="layer">{{'Layer:' | translate}}</label>
        <select id="layer" class="custom-select custom-select-sm" [(ngModel)]="selectedLayer">
          <option selected disabled>{{'Select layer' | translate}}</option>
          <option *ngFor="let layer of layers" [ngValue]="layer.id">{{layer.name | translate}}</option>
        </select>
      </div>
      <div class="form-group">
        <label for="prefix">{{'Prefix:' | translate}}</label>
        <input id="prefix" class="form-control form-control-sm" [(ngModel)]="prefix"
               placeholder="{{'Prefix for automap' | translate}}">
      </div>
      <div class="form-group">
        <label for="postfix">{{'Postfix:' | translate}}</label>
        <input id="postfix" class="form-control form-control-sm" [(ngModel)]="postfix"
               placeholder="{{'Postfix for automap' | translate}}">
      </div>
      <button [attr.data-btnId]="getElementId('automap')" class="btn btn-outline-primary btn-sm" (click)="automap()">
        Automap
      </button>
    </div>
    <table class="table table-sm">
      <thead>
      <tr>
        <th style="width: 40%;">
          {{'VIVO name' | translate}}
        </th>
        <th style="width: 20%;">
          {{'Type' | translate}}
        </th>
        <th style="width: 40%;">
          {{'REGO mapping' | translate}}
        </th>
      </tr>
      </thead>
      <tbody *qmLoading="loading">
      <ng-template ngFor let-asset [ngForOf]="assetList">
        <tr [ngClass]="getRowClass(asset)" *ngIf="assetVisible(asset)">
          <td style="width: 40%;">{{getAssetName(asset)}}</td>
          <td style="width: 20%;">{{getAssetType(asset)}}</td>
          <td style="width: 40%;">
              <span *ngIf="asset._id !== editAsset?._id; else editor;" (click)="setEditAsset(asset);">
                <ng-container *ngIf="mappingList[asset._id];">
                  {{getTitle(mappingList[asset._id].regoId)}}
                </ng-container>
                <ng-container *ngIf="!mappingList[asset._id];">
                  {{'Asset not mapped' | translate}}
                </ng-container>
              </span>
          </td>
        </tr>
      </ng-template>
      </tbody>
    </table>
    <div style="width: 100%; margin-top: 0.2em;" class="d-flex justify-content-center">
      <ngb-pagination
        (pageChange)="turnPage($event)"
        [(page)]="pagination.page"
        [pageSize]="pagination.limit"
        [maxSize]="10"
        [collectionSize]="pagination.total"></ngb-pagination>
    </div>
  </div>
</div>
<ng-template #rt let-r="result" let-t="term">
  <ngb-highlight [result]="r"></ngb-highlight>
</ng-template>

<ng-template #editor>
  <div class="d-flex">
    <div style="flex-grow: 1;">
      <input #searchField type="search" id="this" class="form-control form-control-sm search-control" placeholder="{{'Search for Asset' | translate}}"
             [(ngModel)]="query" qmDebounce [delay]="100"
             (onDebounce)="doSearch();" [autofocus]="true" [qmAutofocus]="true">
      <div class="search-list" *ngIf="query && autocompleteResults?.length > 0">
        <ul>
          <li 
            *ngFor="let single of autocompleteResults"
            [ngClass]="{'selected-item': single.id === currentMapping}"
          >
            <a (click)="selectMapObject(single)">
              {{single.title}}
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div style="margin: 0 10px;">
      <a [attr.data-btnId]="getElementId('saveMapping')" class="text-success" (click)="saveAssetMapping();">
        <svg class="svg-inline--fa fa-w-20">
          <use xlink:href="#check"></use>
        </svg>
      </a>
      <a [attr.data-btnId]="getElementId('editMapping')" class="text-info" (click)="setEditAsset({});">
        <svg class="svg-inline--fa fa-w-20">
          <use xlink:href="#times"></use>
        </svg>
      </a>
      <a [attr.data-btnId]="getElementId('unmap')" class="text-info" (click)="UnMapDevice()">
        <svg class="svg-inline--fa fa-w-20">
          <use xlink:href="#trash"></use>
        </svg>
      </a>
    </div>
  </div>
</ng-template>

<i class="far fa-check" data-fa-symbol="check"></i>
<i class="far fa-times" data-fa-symbol="times"></i>
<i class="far fa-trash-alt" data-fa-symbol="trash"></i>
